import { Page } from "@nucleus/ui-base";

/**
 * NUC-262 — F is no longer constrained to extend the local {@code Filter}
 * abstract base. After the OpenAPI consolidation, tenant UIs consume
 * lib-owned filter classes (NucleusAuditFilter / NucleusMailFilter etc.)
 * that don't share the local Filter base. Both shapes coexist here: the
 * only behaviour FilterRequest cascades is {@code reset()}, which we now
 * guard at call-time instead of requiring at the type level.
 */
export class FilterRequest<F> {
    constructor(public filter: F) {}

    public page: Page = new Page();

    public reset() {
        const maybe = this.filter as { reset?: () => void } | null | undefined;
        maybe?.reset?.();
        this.page.reset();
    }
}
